import React from "react";
import { Box, TextField, Autocomplete, Button } from "@mui/material";
import FormDialog from "@components/FormDialog";
import { useTranslation } from "react-i18next";
import { DriverGroup } from "@lib/types/driver_group";

interface Props {
  viewDriverGroupDialogOpen: boolean;
  setViewDriverGroupDialogOpen: (open: boolean) => void;
  driverGroupData?: DriverGroup; // Data passed as prop
}

const ViewDriverGroup: React.FC<Props> = ({
  viewDriverGroupDialogOpen,
  setViewDriverGroupDialogOpen,
  driverGroupData,
}) => {
  const { t } = useTranslation();

  return (
    <FormDialog
      title={t("user.driverGroups.view")}
      open={viewDriverGroupDialogOpen}
      onClose={() => setViewDriverGroupDialogOpen(false)}
      submitText={t("general.close")}
    >
      {driverGroupData && (
        <form noValidate>
          <Box display="flex" flexDirection="column" gap={2} py={2}>
            <TextField
              label={t("user.drivers.name")}
              variant="outlined"
              fullWidth
              value={driverGroupData.name}
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label={t("user.drivers.description")}
              variant="outlined"
              fullWidth
              value={driverGroupData.description}
              InputProps={{
                readOnly: true,
              }}
            />

            <Autocomplete
              multiple
              options={driverGroupData.drivers || []}
              value={
                driverGroupData.drivers?.filter((driver) =>
                  driverGroupData.drivers?.includes(driver)
                ) || []
              }
              disableClearable
              readOnly
              isOptionEqualToValue={(option, value) =>
                option.driver_id === value.driver_id
              }
              getOptionLabel={(option) => option.name || ""}
              renderOption={(props, option) => (
                <li {...props} key={`${option.name}-${option.driver_id}`}>
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("user.bindings.driver")}
                  variant="outlined"
                />
              )}
            />
          </Box>
        </form>
      )}
    </FormDialog>
  );
};

export default ViewDriverGroup;
